import __request__ from "routing/request";
export function getPage(sort = "NAME", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/token_usage/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
